import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

const Card = ({ children, onClick }) => (
  <S.Container $clickable={onClick} onClick={onClick}>
    {children}
  </S.Container>
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

export default Card;
